
import {map, tap} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment'
import { MsgResult } from 'app/core';

@Injectable()
export class DownloadService {
  private domainStr: string;

  constructor(private http: Http) {
    this.domainStr = environment.baseWebApiUrl;

  }

  downloadRateAuditFile(auditID: string) {
    return this.http.get(this.domainStr + "api/AuditStd/SetupDownload?auditID=" + auditID).pipe(
      tap(response => {
        window.location.assign(this.domainStr + "Download?downloadID=" + response.json());
      }));
  }
  downloadBARProcessorFile(filename: string) {
    return this.http.get(this.domainStr + "api/AuditStd/SetupBARDownload?filename=" + filename).pipe(
      tap(response => {
        window.location.assign(this.domainStr + "Download/BARProcessor?downloadID=" + response.json());
      }));
  }

  downloadUsageReport(filterStartDate, filterEndDate, selectedAmadeus, selectedApollo, selectedGalilio,
    selectedSabre, selectedWorldspan, selectedAccountNameList, SelectedReport) {
    let myData = {
      startDate: filterStartDate, endDate: filterEndDate, IncludeAmadeus: selectedAmadeus, IncludeApollo: selectedApollo, IncludeGalileo: selectedGalilio,
      IncludeSabre: selectedSabre, IncludeWorldspan: selectedWorldspan, AccountIDList: selectedAccountNameList, ReportSelected: SelectedReport
    };
    return this.http.post(this.domainStr + 'api/Report/UsageReportDownload?parameterList', myData).pipe(
      tap(response => {
        window.location.assign(this.domainStr + "Download/DownloadUsageReports?guidStr=" + response.json());
      }));
  }

  downloadSummaryReport(parameterlist) {
    return this.http.get(this.domainStr + 'api/Report/SummaryReportDownload?parameterlist=' + parameterlist).pipe(
      tap(response => {
        window.location.assign(this.domainStr + "Download/DownloadSummaryReport?guidStr=" + response.json());
      }));
  }

  downloadRAReport(auditid:string, auditScheduleID:string, reportName:string):Observable<Observable<string>>  {
    let parameterList = {AuditID: auditid, ASC:auditScheduleID, SSRS_Parameter_List:'AuditScheduleID', SSRS_Report_Name: reportName };
    return this.http.post(this.domainStr +'api/Report/ReportDownload', parameterList).pipe(
    map( res => {
      let guidStr = res.json();
      return this.http.post(this.domainStr + 'Download/DownloadReports', {guidStr:guidStr}).pipe(
        map( res2 => res2.json().delalyedDataId));
    }));
  }


  downloadReport(auditid:string, reportName:string):Observable<Observable<string>>  {
    let parameterList = {AuditID:auditid, SSRS_Parameter_List:'AuditID', SSRS_Report_Name: reportName };
    return this.http.post(this.domainStr +'api/Report/ReportDownload', parameterList).pipe(
    map( res => {
      let guidStr = res.json();
      return this.http.post(this.domainStr + 'Download/DownloadReports', {guidStr:guidStr}).pipe(
        map( res2 => res2.json().delalyedDataId));
    }));
  }

  downloadReverseAuditReportStart(parameterList:string):Observable<Observable<string>> {
    return this.http.post(this.domainStr + 'api/Report/ReverseAuditReportDownload', JSON.stringify( parameterList), { headers: new Headers({ 'Content-Type': 'application/json' }) }).pipe(
      map( res => {
        let data = res.json();
        return this.http.post(this.domainStr + 'Download/DownloadReverseAuditReport', {guidStr:data}).pipe(
          map( res2 => res2.json().delalyedDataId));
      }));
  }
  downloadReportComplete(guidStr:string) {
        window.location.assign(this.domainStr +"Download/DelayedReport?delalyedDataId=" + guidStr);
  }
  downloadReportStatusUpdate(guidStr:string):Observable<boolean|MsgResult> {
    return this.http.post(this.domainStr + 'api/Report/IsReportReady', JSON.stringify( guidStr), { headers: new Headers({ 'Content-Type': 'application/json' }) } ).pipe(
    map(  response => {
      const data = response.json();
      return  data;
    }))
  }

  //download full report to excel (Interactive report Viewer)
  downloadInteractiveReportToExcel(auditId: any, auditScheduleId: any, doneFunc:Function) {
    var OutputFormat = 'EXCELOPENXML';
    let myData = { AID: auditId, ASC: auditScheduleId, FRM: OutputFormat };
    return this.http.post(this.domainStr + 'api/Report/InteractiveReportToExcel', myData).pipe(
      tap(response => {
        let url = this.domainStr + "Download/DownloadInteractiveReportToExcel?guidStr=" + response.json();
        window.location.assign(url);
        doneFunc();
      }));
  }

  downloadRAWReport(auditid: string, auditScheduleId: string, reportName: string, doneFunc:Function ) {
    let parameterList = { ASC: auditScheduleId, SSRS_Parameter_List: 'AuditScheduleID', SSRS_Report_Name: reportName };
    return this.http.post(this.domainStr + 'api/Report/RAWReportDownload', parameterList).pipe(
      tap(response => {
        window.location.assign(this.domainStr + "Download/DownloadRAReport?guidStr=" + response.json());
        doneFunc();
      }));
  }

  downloadCustomReport(parameterlist) {
    let parameterList = parameterlist;
    return this.http.post(this.domainStr + 'api/Report/CustomReportDownload', parameterList).pipe(
      tap(response => {
        window.location.assign(this.domainStr + "Download/DownloadCustomReport?guidStr=" + response.json());
      }));
  }
  downloadAdminReport(parameterlist: string) {
    let parameterList = parameterlist;
    return this.http.post(this.domainStr + 'api/Report/AdmninReport', JSON.stringify(parameterList), { headers: new Headers({ 'Content-Type': 'application/json' }) }).pipe(
      tap(response => {
        window.location.assign(this.domainStr + "Download/AdmninReport?guidStr=" + response.json());
      }));
  }
  downloadFailedEmailReport(startDate: Date) {
    let parameterList = {  StartDate: startDate};
    return this.http.post(this.domainStr + 'api/Report/FailedEmailNotificationsReport', parameterList).pipe(
      tap(response => {
        window.location.assign(this.domainStr + "Download/DownloadFailedEmail?guidStr=" + response.json());
      }));
  }


}

